"use client";
import { useState } from "react";
import { c } from "@/lib/vster/theme";
import Icon from "@/components/vster/Icon";

// 공고문 신고 — 수퍼유저 전용. 상단 '신고하기' 버튼 → 모달(공고문 아이디 + 내용) → POST /api/reports.
export default function ReportButton({ docId }: { docId: number }) {
  const [open, setOpen] = useState(false);
  const [rid, setRid] = useState(String(docId));
  const [content, setContent] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const close = () => { setOpen(false); setErr(null); setDone(false); setContent(""); setRid(String(docId)); };

  async function submit() {
    setErr(null);
    if (!content.trim()) { setErr("신고 내용을 입력하세요."); return; }
    setBusy(true);
    try {
      const res = await fetch("/api/reports", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ docId: rid.trim() === "" ? null : Number(rid), content }),
      });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) { setErr(d.error ?? "신고 접수에 실패했습니다."); setBusy(false); return; }
      setDone(true); setBusy(false);
    } catch { setErr("처리 중 오류가 발생했습니다."); setBusy(false); }
  }

  const field: React.CSSProperties = { width: "100%", border: `1px solid ${c.line}`, borderRadius: 9, padding: "10px 12px", fontFamily: "inherit", fontSize: 14.5, color: c.ink, background: c.surface, outline: "none", boxSizing: "border-box" };

  return (
    <>
      <button
        type="button" onClick={() => setOpen(true)} title="이 공고문을 신고합니다 (관리자 검토)"
        style={{ display: "inline-flex", alignItems: "center", gap: 5, border: `1px solid ${c.line}`, background: c.surface, color: c.danger ?? "#d33", borderRadius: 9, padding: "8px 12px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}
      >
        <Icon name="flag" size={16} />신고하기
      </button>

      {open && (
        <div onClick={close} style={{ position: "fixed", inset: 0, background: "rgba(14,23,38,.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ width: "100%", maxWidth: 480, background: c.surface, borderRadius: 16, border: `1px solid ${c.line}`, boxShadow: "0 20px 60px -20px rgba(5,26,62,.4)", padding: 22 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
              <h3 style={{ fontSize: 17, fontWeight: 800, color: c.ink, margin: 0, display: "flex", alignItems: "center", gap: 6 }}><Icon name="flag" size={19} color={c.danger ?? "#d33"} />공고문 신고하기</h3>
              <button type="button" onClick={close} style={{ border: "none", background: "none", cursor: "pointer", color: c.muted }}><Icon name="close" size={22} /></button>
            </div>

            {done ? (
              <div style={{ textAlign: "center", padding: "20px 0" }}>
                <Icon name="check_circle" size={40} color={c.action} />
                <p style={{ fontSize: 15, fontWeight: 700, color: c.ink, margin: "10px 0 4px" }}>신고가 접수되었습니다.</p>
                <p style={{ fontSize: 13, color: c.muted, margin: 0 }}>관리자 페이지에서 확인·처리됩니다.</p>
                <button type="button" onClick={close} style={{ marginTop: 16, background: c.ink, color: "#fff", border: "none", borderRadius: 9, padding: "10px 24px", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>닫기</button>
              </div>
            ) : (
              <>
                <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: c.muted, margin: "0 0 4px" }}>관련 공고문 아이디</label>
                <input value={rid} onChange={(e) => setRid(e.target.value.replace(/[^0-9]/g, ""))} inputMode="numeric" placeholder="예: 40462" style={{ ...field, marginBottom: 12 }} />

                <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: c.muted, margin: "0 0 4px" }}>신고 내용 <span style={{ color: c.danger ?? "#d33" }}>*</span></label>
                <textarea value={content} onChange={(e) => setContent(e.target.value)} rows={5} placeholder="문제 내용을 구체적으로 적어주세요 (예: 마감일 오류, 잘못된 첨부, 비지원 오분류 등)" style={{ ...field, resize: "vertical", lineHeight: 1.6 }} />

                {err && <p style={{ fontSize: 12.5, fontWeight: 600, color: c.dangerText ?? "#c00", margin: "10px 0 0" }}>{err}</p>}

                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 18 }}>
                  <button type="button" onClick={close} disabled={busy} style={{ border: `1px solid ${c.line}`, background: c.surface, color: c.muted, borderRadius: 9, padding: "10px 18px", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>취소</button>
                  <button type="button" onClick={submit} disabled={busy || !content.trim()} style={{ background: c.danger ?? "#d33", color: "#fff", border: "none", borderRadius: 9, padding: "10px 22px", fontSize: 14, fontWeight: 700, cursor: busy || !content.trim() ? "not-allowed" : "pointer", opacity: busy || !content.trim() ? 0.5 : 1, fontFamily: "inherit" }}>{busy ? "접수 중…" : "신고하기"}</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
